import { SecurityRole } from './CommonTypes/PeoplePageTypes';
import { ICustomRole, IUser } from '../redux/types';

export function hasGrant(user: IUser | undefined, grant: string): boolean {
  if (!user?.signedIn) return false;
  if (!user.CustomRole) return true;
  if (user.CustomRole.Grants?.indexOf(grant) >= 0) return true;
  if (grant.endsWith('.view')) {
    const manage = grant.slice(0, -'.view'.length) + '.manage';
    return user.CustomRole.Grants?.indexOf(manage) >= 0;
  }
  return false;
}

export function isRestrictedStaff(user: IUser | undefined): boolean {
  return !!user?.CustomRole;
}

export function securityLevelNumber(user?: IUser | null): number {
  const raw = user?.SecurityLevel as unknown;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    const asNum = Number(trimmed);
    if (trimmed !== '' && Number.isFinite(asNum)) return asNum;
    if (trimmed in SecurityRole) {
      const mapped = SecurityRole[trimmed as keyof typeof SecurityRole];
      if (typeof mapped === 'number') return mapped;
    }
  }
  return SecurityRole.Unknown;
}

/** Staff, admin, superadmin/Yoda, owner — anyone at clearance 7 or above. */
export function isStaffUser(user?: IUser | null): boolean {
  if (!user) return false;
  if (securityLevelNumber(user) >= SecurityRole.Staff) return true;
  if (user.Admin) return true;
  if (user.isSuperUser) return true;
  if (user.isOwner) return true;
  return false;
}

export function isAdminUser(user: IUser | undefined): boolean {
  return securityLevelNumber(user) >= SecurityRole.Admin;
}

export function customRoleLabel(role: ICustomRole | null | undefined): string {
  return role?.Name || 'Full Staff';
}
